import { render, staticRenderFns } from "./RevitElementView.vue?vue&type=template&id=13969536"
import script from "./RevitElementView.vue?vue&type=script&lang=ts"
export * from "./RevitElementView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports